// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LoadingIndicator_overlay__pHEHM","visuallyHidden":"LoadingIndicator_visuallyHidden__1IxpP"};